import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';

export function useLogout() {
  const { logout } = useAuth();

  // Delegate entirely to AuthContext.logout which:
  // 1. Sets isLoggingOut flag to suppress proactive token refresh
  // 2. Calls POST /api/auth/logout to clear httpOnly cookies on the backend
  // 3. Clears localStorage and in-memory auth state (best-effort)
  return useMutation({
    mutationFn: () => logout(),
  });
}
